import React, { FC } from 'react';
import { AdyenStoreTerminals_operativeViewer_adyenStore_terminals } from './__queries__';
import { AdyenTerminal, useStorage } from '~Components/Storage';
import { Box } from '~Styles';
import AvailableTerminal from './AvailableTerminal';
import useI18n from '~Translations';
import Heading from '~ComponentsImproved/Typography/Heading';

interface Props {
  addedTerminals: AdyenTerminal[];
  availableVenueTerminals: AdyenStoreTerminals_operativeViewer_adyenStore_terminals[];
  onComplete?: () => void;
}

const AvailableTerminals: FC<Props> = ({
  addedTerminals,
  availableVenueTerminals,
  onComplete,
}) => {
  const [, updateStorage] = useStorage();
  const { i18n } = useI18n();

  const terminalIdHasPrinter = (id: string) => !id.toLowerCase().startsWith('p');

  const handleAdd = (terminal: AdyenStoreTerminals_operativeViewer_adyenStore_terminals) => {
    // If we find a terminal with the same id, we remove it from the list since the IP might have changed
    const filteredTerminals = addedTerminals.filter((at) => at.POIID !== terminal.id);

    updateStorage({
      adyenTerminals: [
        ...filteredTerminals,
        {
          IP: null,
          POIID: terminal.id,
          hasPrinter: terminalIdHasPrinter(terminal.id),
        },
      ],
    });

    onComplete && onComplete();
  };

  if (availableVenueTerminals.length === 0) {
    return null;
  }

  const availableTerminals = availableVenueTerminals.filter((terminal) => {
    return !addedTerminals.some((addedTerminal) => addedTerminal.POIID === terminal.id);
  });

  return (
    <div>
      {availableTerminals.length > 0 && (
        <Box marginBottom="xl">
          <Heading level={4} bottom={8} color="#fff">
            {i18n('Settings.AvailableTerminals')}
          </Heading>
          <div>
            {availableTerminals.map((terminal) => (
              <AvailableTerminal
                key={terminal.id}
                id={terminal.id}
                onAdd={() => handleAdd(terminal)}
              />
            ))}
          </div>
        </Box>
      )}
    </div>
  );
};

export default AvailableTerminals;
